import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('glove-buyer-guide', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./glove-buyer-guide-landing')
        ),
);
